import { initToc } from "../modules/toc.js";
jQuery(($) => initToc($));
